module.exports = "/assets/restaurant-placeholder@2x.png?hc2htUD";